<div class="bg5 pt-3 pb-3">

  <div class="container">

    <!-- Breadcrumb -->
    <div class="divshbreadcum mt-3 mb-4 pt-2 pb-2 pe-3 ps-3">
      <div class="row">
        <div class="col-sm-12">
          <div class="shbreadcum">
            <table>
              <tr>
                <td class="separator">
                  <h6 class="pt-2 mt-1 me-3">
                    <strong>
                      <a (click)="back()" class="c1 pointer">
                        <img src="/assets/images/icons/ic_round-navigate-next.png" class="backicon"> Back
                      </a>
                    </strong>
                  </h6>
                </td>
                <td>
                  <h6 class="mb-1 mt-2 ms-3">
                    <strong class="c1">
                      <a class="c1 pointer" href="/procurement/rfq-list">My RFQ</a> > <a class="c1 pointer" href="/procurement/rfq/quoted/detail/{{rfqId}}"> Quoted RFQ > </a> <a class="c1 pointer" href="/procurement/rfq/proforma-po/{{rfqId}}"> Proforma PO List > </a> <font class="text-muted">Proforma PO Detail</font>
                    </strong>
                  </h6>
                </td>
              </tr>
            </table>
          </div>
        </div>
        <!-- <div class="col-sm-5">
        </div> -->
      </div>
    </div>

    <div class="mt-3">

      <!-- Saat page loading -->
      <div *ngIf="PageLoading">
        <div class="text-center pt-5 pb-5">
          <div class="loader loader--style8" title="7">
            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="24px" height="30px" viewBox="0 0 24 30"
              style="enable-background:new 0 0 50 50;" xml:space="preserve">
              <rect x="0" y="10" width="4" height="10" fill="#333" opacity="0.2">
                <animate attributeName="opacity" attributeType="XML" values="0.2; 1; .2" begin="0s" dur="0.6s"
                  repeatCount="indefinite" />
                <animate attributeName="height" attributeType="XML" values="10; 20; 10" begin="0s" dur="0.6s"
                  repeatCount="indefinite" />
                <animate attributeName="y" attributeType="XML" values="10; 5; 10" begin="0s" dur="0.6s"
                  repeatCount="indefinite" />
              </rect>
              <rect x="8" y="10" width="4" height="10" fill="#333" opacity="0.2">
                <animate attributeName="opacity" attributeType="XML" values="0.2; 1; .2" begin="0.15s" dur="0.6s"
                  repeatCount="indefinite" />
                <animate attributeName="height" attributeType="XML" values="10; 20; 10" begin="0.15s" dur="0.6s"
                  repeatCount="indefinite" />
                <animate attributeName="y" attributeType="XML" values="10; 5; 10" begin="0.15s" dur="0.6s"
                  repeatCount="indefinite" />
              </rect>
              <rect x="16" y="10" width="4" height="10" fill="#333" opacity="0.2">
                <animate attributeName="opacity" attributeType="XML" values="0.2; 1; .2" begin="0.3s" dur="0.6s"
                  repeatCount="indefinite" />
                <animate attributeName="height" attributeType="XML" values="10; 20; 10" begin="0.3s" dur="0.6s"
                  repeatCount="indefinite" />
                <animate attributeName="y" attributeType="XML" values="10; 5; 10" begin="0.3s" dur="0.6s"
                  repeatCount="indefinite" />
              </rect>
            </svg>
          </div>
        </div>
      </div>

      <!-- Saat page tidak loading -->
      <div class="pb-5" *ngIf="!PageLoading">

        <!-- Jika RFQ tidak ditemukan  -->
        <div *ngIf="getPoListData?.length == 0" class="empty-product">
          <div class="bg-secondary bg-gradient rounded-3 pt-5 pb-5 mb-5 text-center">
            <h1 class="text-light bi bi-file-earmark-ruled" style="font-size: 80px;"></h1>
            <h6 class="text-light">RFQ ID Not Found.</h6>
          </div>
        </div>


        <!-- Jika ada RFQ -->
        <div class="mb-4" *ngIf="getPoListData != []">
          <!-- RFQ Summary -->
          <div class="card divrfqlist">
            <div class="card-header bg-dark card-header-bg">
              <div class="row c3 fw-bold">
                <div class="col-4 text-start ps-5 pe-0">RFQ # {{ this.formatDisplayId(getPoListData?.poRfqData?.rfqDisplayId) }}</div>
                <div class="col-3 text-start ps-5">Valid until : {{getPoListData?.poRfqData?.submitQuotationLastDate | date:'d MMM y'}}
                </div>
                <div class="col-1 text-center"></div>
                <div class="col-4 text-end pe-4">Vendor Participating : {{ getPoListData?.poListData?.length }}</div>
              </div>
            </div>
            <div class="card-body">
              <!-- <div class="row text-start ps-3">
                <div class="col-10" [ngSwitch]="DataRfq.rfqState | uppercase">
                  <i class="bi bi-geo-alt-fill bi-geo-color"></i> {{getPoListData?.poRfqData?.rfqDeliveryProvince}},
                  {{getPoListData?.poRfqData?.rfqDeliveryCountry}}
                  <span *ngSwitchCase="'UNPUBLISHED'" class="badge rounded-pill bg-unpublished ms-3"> UNPUBLISHED
                  </span>
                  <span *ngSwitchCase="'PUBLISHED'" class="badge rounded-pill bg-published ms-3"> PUBLISHED </span>
                  <span *ngSwitchCase="'EXPIRED'" class="badge rounded-pill bg-expired ms-3"> EXPIRED </span>
                </div>
                <div class="col-2 text-center">
                  <span class="badge bg-success p-2">PARTICIPATING</span>
                </div>
              </div> -->
              <div class="row text-start ps-3 fw-bold">
                <div class="col-sm-6">
                  Category : {{(getPoListData?.poRfqData?.rfqVendorCategory.length>0)?getPoListData?.poRfqData?.rfqVendorCategory.join(", "):'-'}}
                  <p class="card-text">{{divDetailspec(getPoListData?.poRfqData?.description)}}</p>
                </div>
                <div class="col-sm-6 text-end">
                  <strong *ngIf="getDetailPpo(PoId,'isSent')" class="mt-1">
                    <img src="/assets/images/icons/ic_outline-request-quote.png" class="outlineicon pb-2"> 
                    <font>PO sent</font>
                  </strong>
                  <label class="ms-3 c4 " *ngIf="getDetailPpo(PoId,'isVoid')"><strong>VOID</strong></label>

                </div>
              </div>
            </div>
          </div>

          <!-- Quotation -->
          <form [formGroup]="rfqForm" (ngSubmit)="onSubmit()">
            <div class="container pt-4 pb-5" id="rfqFormDiv">
              <div class="row pb-5">
                <div class="col-md-12 divprodlist">
                  <div class="row rounded-top fhbgcyan text-white">
                    <div class="col-sm-6 mt-0 pt-3 mb-3 ps-5">
                      <h4 class="mb-0">Proforma PO Detail
                      </h4>
                    </div>
                    <div class="col-sm-6 mt-0 pt-3 mb-3 pe-5 text-end">
                    </div>
                  </div>
                  <!-- Detail -->
                  <!-- Section 1 a-->

                  <!-- Line break -->
                  <div class="row">
                    <div class="col-sm-12 ps-5 pe-5 mb-4 mt-4">
                        <small class="fhnotes">
                            <strong>
                            Congratulations! Your company has been selected to fulfill below order by the customer. <br>
                            IMPORTANT : Please note that this is Proforma PO and is NOT binding. Please Contact the customer for a binding PO. This is a auto-generated Proforma PO. Please click <a class="pointer c1"><u>here to Review FH terms and conditions</u></a>.
                            </strong>
                        </small>
                    </div>
                  </div>
                  
                  <div class="row ps-5 pe-5 mb-3">
                      <div class="col-sm-6 p-0">
                            <div class="potable">
                                <table>
                                    <tr>
                                        <td><strong>Currency</strong></td>
                                        <td><strong>:</strong></td>
                                        <td>{{ getPoDetail?.rfqCurrency }}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>ETA Required</strong></td>
                                        <td><strong>:</strong></td>
                                        <td>
                                          <font *ngIf="getPoListData?.poRfqData?.etaRequested">{{getPoListData?.poRfqData?.etaRequested | date:'d MMM y'}}</font>
                                          <font *ngIf="!getPoListData?.poRfqData?.etaRequested">-</font>
                                          </td>
                                    </tr>
                                    <tr>
                                        <td><strong>Payment Term</strong></td>
                                        <td><strong>:</strong></td>
                                        <td>{{(getPoListData?.poRfqData?.paymentTermRequestedInDays) ? getPoListData?.poRfqData?.paymentTermRequestedInDays+' Days':'-'}}</td>
                                    </tr>
                                </table>
                            </div>
                      </div>
                      <div class="col-sm-6  p-0">
                          <div>
                              <h6 class="c1 text-end"><b>PO Id : # {{formatDisplayId(getPoDetail?.poNumber)}}</b></h6>
                          </div>
                    </div>
                  </div>

                  <div class="row pt-3 pb-3">
                      <div class="col-sm-6">
                        <div class="row justify-content-center">
                            <div class="col-8 rfq-detail-quote p-4">
                              <div class="">
                                  <div class="row">

 
                                    <div class="col-12 text-start fw-bold c1">Quoted for : {{getPoDetail?.procurementDetailAddress?.companyName}}</div>
                                      <div class="col-12 text-start fw-bold">Shipping Address</div>
                                      <div class="col-12  text-start">
                                            {{getPoDetail?.procurementDetailAddress?.companyMainStreet}}<br>
                                            {{getPoDetail?.procurementDetailAddress?.companyMainCity}} {{getPoDetail?.procurementDetailAddress?.companyMainPostalCode}}<br>
                                            {{getPoDetail?.procurementDetailAddress?.companyMainCountry}}<br>
                                            <br>
                                            Phone : {{getPoDetail?.procurementDetailAddress?.companyMainPhone}}<br>
                                            Email : {{getPoDetail?.procurementDetailAddress?.companyMainEmail}}
                                        <div class="text-start fw-bold">Internal Ref. No. : {{getPoListData?.poRfqData?.procurementRefNumber}}</div>
                                      </div>
                                  </div>
                              </div>
                            </div>
                          </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="row justify-content-center">
                            <div class="col-8 rfq-detail-quote-vendor p-4">
                              <div class="">
                                  <div class="row">


                                    <div class="col-12 text-start fw-bold c1">{{getPoDetail?.vendorName}}</div>
                                      <div class="col-12 text-start fw-bold">Shipping to</div>
                                      <div class="col-12 text-start">{{ getPoDetail?.quotationOfferedDeliveryAddress }}<br></div>
                                      <div class="col-12 text-start fw-bold">Address</div>
                                      <div class="col-12  text-start">
                                          
                                          {{ getPoDetail?.vendorAddress }}<br>
                                          <br>
                                          Phone : {{getPoDetail?.vendorPhone}}<br>
                                          Email : {{getPoDetail?.vendorEmail}}
                                        <div class="text-start fw-bold">Internal Ref. No. : {{getPoListData?.vendorRefNumber}}</div>
                                      </div>
                                  </div>
                              </div>
                            </div>
                          </div>
                      </div>
                  </div>



                  <!-- Section 2 -->
                  <div class="row">
                    <!-- <div class="col-sm-10 p-5 pt-3 pb-1">
                      <label class="c1" for="listproduct"><strong>Total Vendor : {{ getPoListData?.poListData.length }}</strong></label>
                    </div>
                    <div class="col-sm-2 p-5 pt-3 pb-1">
                    </div> -->
                    <!-- Product List -->
                    <div class="col-sm-12 p-5 pt-0 pb-0">
                      <div class="mb-3 mt-5 row">
                        <div class="container">


                            <div class="table-responsive">
                                <table class="table tableqrfq mb-0">
                                    <tr>
                                        <th class="text-center">#</th>
                                        <th class="text-left">Manf. Prod. No.</th>
                                        <th class="text-left">Brand</th>
                                        <th class="text-left">Product Description</th>
                                        <th class="text-center">QTY Offer</th>
                                        <th class="text-center">Price</th>
                                        <th class="text-center">Line Total</th>
                                    </tr>
                                    <tr *ngFor="let product of getPoDetail?.PoItem; let i = index">

    

                                        <td class="titleVendor">{{ i+1 }}</td>
                                        <td class="titleVendor">{{ product.productManufacturerCode }}</td>
                                        <td class="titleVendor">{{ product.productBrand }}</td>
                                        <td class="titleVendor">{{ divDetailspec(product.productDescription) }}</td>
                                        <td class="text-end">{{ product.selectedQty | number }}</td>
                                        <td class="text-end">{{ getPoDetail?.rfqCurrency }} {{ product.productPrice | number }}</td>
                                        <td class="text-end">{{ getPoDetail?.rfqCurrency }} {{ product.selectedQty * product.productPrice | number }}</td>
                                    </tr>
                                </table>
                            </div>


                        </div>
                      </div>
                    </div>
                  </div>


                  <div class="row pb-5">
                    <div class="col-sm-12 p-5 pt-0 pb-0">
                      <div class="mb-3">
                        <div class="row g-0">

                            <div class="col-sm-6"></div>
                            <div class="col-sm-3 text-end">Subtotal</div>
                            <div class="col-sm-3 text-end pe-1">{{ getPoDetail?.rfqCurrency }} {{totalPODetail | number}}
                            </div>



                            <!-- "vendorIsTaxIncluded": false,
                            "vendorTaxPercentage": 10,
                            "vendorTaxValue": null, -->
                            <div class="col-12">
                                <div class="row g-0" *ngIf="!getPoDetail?.vendorIsTaxIncluded">
                                    <div class="col-sm-6"></div>
                                    <div class="col-sm-3 text-end" >
                                        {{ (getPoDetail?.taxValue) ?  'Tax' : 'Tax('+getPoDetail?.vendorTaxPercentage+'%)'  }}
                                    </div>
                                    <div class="col-sm-3 text-end pe-1">{{totalPOTax | number}}
                                    </div>        
                                </div>
                                <div class="row g-0" *ngIf="getPoDetail?.vendorIsTaxIncluded">
   
                                </div>
                            </div>

                            
                            <div class="col-sm-6"></div>
                            <div class="col-sm-3 text-end"><strong>Total</strong></div>
                            <div class="col-sm-3 text-end pe-1">
                                <strong>{{getPoListData?.poRfqData?.currency}} {{ totalPODetail + totalPOTax |  number }}</strong>
                                <font style="display: none;">{{ getPoListData?.totalActivePrice |  number }}</font>
                            </div>

                        </div>
                      </div>
                    </div>
                  </div>
                  

                  <!-- Section 2 alternative -->
                  <div class="row"  *ngIf="alternativeItemList.length>0">
                    <div class="col-sm-10 p-5 pt-3 pb-1">
                      <label class="" for="listproductalt"><strong>Product You Might be Interested</strong></label>
                    </div>
                    <div class="col-sm-2 p-5 pt-3 pb-1">
                    </div>
                    <!-- Product List -->
                    <div class="col-sm-12 p-5 pt-0 pb-0">
                      <div class=" row">
                        <div class="container">
                          <ul class="list-group rounded-0">

                            <!-- alternativeProductBrand: "String!"
                            alternativeProductDesc: "String!"
                            alternativeProductManufacturerCode: "String!"
                            alternativeProductName: "String!"
                            id: "01FK100XJG70C6EY56ET47BGYJ"
                            priceOffered: 10000
                            productId: null
                            qtyOffered: 20
                            rfqItemId: "01FJKF1H83Y -->

                            <li class="list-group-item bg1 p-0 mb-3 rounded shadow border-0 b1 hvshadow"
                              *ngFor="let product of alternativeItemList; let i = index"
                              [ngClass]="{ 'bg4': submitted && (CheckVal(ValmanufacturerSku[i]) || CheckVal(Valbrand[i]) || CheckVal(ValqtyNeeded[i]) ) }">
                              <div class="row m-0 p-0 pointer" (click)="AccordionHideShowAlt(i)">
                                <div class="col-sm-1 p-2 ps-3 fw-bold text-white">{{i+1}}</div>
                                <div class="col-sm-10 p-2 text-center text-white">
                                  <!-- <strong>{{ mappingProductfromRfq(product.rfqItemId,'brand') }} </strong> : {{ mappingProductfromRfq(product.rfqItemId,'name') }} -->
                                <strong>{{ product.alternativeProductBrand }}</strong> : {{ product.alternativeProductName }}
                                
                                </div>
                                <div class="col-sm-1 p-2 text-end fw-bold text-white">
                                  <img
                                    src="/assets/images/icons/{{ (product.collapse) ? 'ic_Dup@2x.png':'ic_Ddown@2x.png' }}"
                                    class="ps-2 pe-2 icondropdown">
                                </div>
                              </div>
                              <!-- Expanded Content -->
                              <div
                                class="bg-white divshadow m-0 p-5 pt-4 rounded-bottom row {{ (product.collapse) ? '':'d-none' }}">
                                <strong class="text-end">Reffer to : {{mappingProductfromRfq(product.rfqItemId,'description')}}</strong>
                                <p><b>Your Offer : </b></p>
                                <div class="col-sm-12 p-4 ms-0 me-5 mb-4 product-detail-quote">

                                  <div class="row mt-2">
                                    <div class="col-2 text-start fw-bold">Product Name</div>
                                    <div class="col-1 text-center">:</div>
                                    <div class="col-2 text-start">{{ product.alternativeProductName }}</div>
                                    <div class="col-2"></div>
                                    <div class="col-2 text-start fw-bold">Price</div>
                                    <div class="col-1 text-center">:</div>
                                    <div class="col-2 text-start">{{ product.priceOffered | number }}</div>
                                  </div>
                                  <div class="row mt-2">
                                    <div class="col-2 text-start fw-bold">Brand</div>
                                    <div class="col-1 text-center">:</div>
                                    <div class="col-2 text-start">{{ product.alternativeProductBrand }}</div>
                                    <div class="col-2"></div>
                                    <div class="col-2 text-start fw-bold">QTY Offered</div>
                                    <div class="col-1 text-center">:</div>
                                    <div class="col-2 text-start">{{ product.qtyOffered }}</div> 
                                  </div>
                                  <div class="row mt-2">
                                    <div class="col-2 text-start fw-bold">Manf. Prod. No.</div>
                                    <div class="col-1 text-center">:</div>
                                    <!-- <div class="col-2 text-start" [innerHTML]="divspec(product.description)"></div> -->
                                    <div class="col-2 text-start">{{ product.alternativeProductManufacturerCode }}</div>

                                    
                                    <div class="col-2"></div>
                                    <div class="col-2 text-start fw-bold">Line Total</div>
                                    <div class="col-1 text-center">:</div>
                                    <div class="col-2 text-start">
                                      
                                      {{ product.priceOffered * product.qtyOffered | number }}

                                    </div>
                                  </div>
                                  <div class="row mt-2">
                                    <div class="col-2 text-start fw-bold">Product Description</div>
                                    <div class="col-1 text-center">:</div>
                                    <!-- <div class="col-2 text-start" [innerHTML]="divspec(product.description)"></div> -->
                                    <div class="col-2 text-start">{{product.alternativeProductDesc }}</div>
                                    <div class="col-2"></div>
                                    <div class="col-2 text-start fw-bold">Specification</div>
                                    <div class="col-1 text-center">:</div>
                                    <div class="col-2 text-start"></div>
                                  </div>
                                </div>

                              </div>




                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>



                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

    <!-- Fixed Bottom Button -->
    <div class="fixed-bottom shadow">



        <div class="" [ngStyle]="{'display':displaytimeline}">
            <div class="divtimeline p-1">
            <div class="card timelinecard">
                <div class="card-header bgtimelineheader">
                <div class="row p-0 ">
                    <div class="col-9">
                    Quotation Status Timeline
                    </div>
                    <div class="col-3 text-end">
                    <i class="bi bi-x-lg text-end pointer" (click)="OpenModalTimeLine()"></i>
                    </div>
                </div>

        
                </div>
                <div class="card-body">

                <div class="timeline">
                    <div class="timeline__event  animated fadeInUp delay-3s timeline__event--type1 {{ StatusApproval==4 ? 'activeLine':'inactiveLine' }} inactiveIcon {{ (StatusApproval==2 || StatusApproval==4) ? 'activeIcon':'' }}"  [ngClass]="{'activeTimeline': (StatusApproval==2 || StatusApproval==4) && Valstate=='UNPUBLISHED'}">
                    <div class="timeline__event__icon ">
                        <i class="lni-cake"></i>
                        <div class="timeline__event__date inactiveTimeline"  [ngClass]="{'activeTimeline': (StatusApproval==2 || StatusApproval==4)}">
                        Approval<br>Requested
                        </div>
                    </div>
                    <!-- <div class="timeline__event__content ">
                        <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit.</p>
                    </div> -->
                    </div>
                    <div class="timeline__event animated fadeInUp delay-2s timeline__event--type2 inactiveIcon {{ StatusApproval==4  ? 'activeIcon':'' }} {{ StatusApproval==4 && Valstate=='PUBLISHED' ? 'activeLine':'inactiveLine' }} ">
                    <div class="timeline__event__icon">
                        <i class="lni-burger"></i>
                        <div class="timeline__event__date inactiveTimeline {{ Valstate!=='UNPUBLISHED' ? 'activeTimeline':'' }}" [ngClass]="{'activeTimeline': StatusApproval==4}">
                          Quotation<br>Approved
                        </div>
                    </div>
                    <!-- <div class="timeline__event__content">
                        <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit.</p>
                    </div> -->
                    </div>
                    <div class="timeline__event animated fadeInUp delay-1s timeline__event--type3 inactiveIcon {{ StatusApproval==4 && Valstate=='PUBLISHED'  ? 'activeIcon':'' }}" style="margin-bottom: 10px !important;">
                    <div class="timeline__event__icon">
                        <i class="lni-slim"></i>
                        <div class="timeline__event__date inactiveTimeline" [ngClass]="{'activeTimeline': StatusApproval==4 && Valstate=='PUBLISHED'}">
                        Publish<br>Quotation
                        </div>
                    </div>
                    <!-- <div class="timeline__event__content">
                        <p>Lorem, ipsum dolor sit amet.</p>
                
                    </div> -->
                    </div>

                
                </div>
                <div class="text-center">
                    <p class="texttimeline" [hidden]='StatusApproval!==1'>Click the “Request Approval” button to process product listing. </p>
                    <p class="texttimeline" [hidden]='StatusApproval!==2'>Please wait, your Quotation is being review</p>
                    <p class="texttimeline" [hidden]='StatusApproval!==4'>
 
                      <font *ngIf='Valstate=="UNPUBLISHED"'>Your Quotation is has been approved</font>
                      <font *ngIf='Valstate=="PUBLISHED"'>Your Quotation is has been approved & published</font>
                      
                    </p>
                    
                    <!-- <button type="button" class="btn btn-primary fhbgblack mt-3 mb-3" disabled>Approval Requested</button> -->



                    <button type="button" (click)="reqeustApproval(quotationId,'REQUEST')" class="btn btn-dark fhbcyan rounded-1 mb-2"  *ngIf="!LoadingreqeustApproval" [hidden]='StatusApproval!==1'>Request Approval</button>
                    <button type="button" class="btn btn-dark fhbcyan rounded-1 mb-2 disabled"  *ngIf="LoadingreqeustApproval" [hidden]='StatusApproval!==1' disabled>Loading...</button>
        
        

        
                    <button type="button" (click)="openModalApproveReject()" *ngIf="CanApproveReject" class="btn fhbcyan w-100 rounded-1 mb-2 text-center text-white pt-2 pb-2" [hidden]='StatusApproval!==2'>Approval Requested</button>
                    
        
                    <font *ngIf="!CanApproveReject" class="fhbcyan rounded-1 mb-2 text-center text-white pt-2 pb-2 ps-3 pe-3" [hidden]='StatusApproval!==2'>Approval Requested</font>
        
        
        
                    
                    
                    <!-- <font class="fhbcyan rounded-1 mb-2 text-center text-white pt-2 pb-2 txtdisabled ps-3 pe-3" [hidden]='StatusApproval!==4'>Approved</font> -->

                    <font class="fhbcyan rounded-1 mb-2 text-center text-white pt-2 pb-2 txtdisabled ps-3 pe-3" *ngIf='StatusApproval==4 && Valstate=="UNPUBLISHED"'>Approved</font>
                    <font class="fhbcyan rounded-1 mb-2 text-center text-white pt-2 pb-2 txtdisabled ps-3 pe-3"  *ngIf='StatusApproval==4 && Valstate=="PUBLISHED"'>Published</font>

                    


                </div>


                </div>
            </div>
            </div>
            
        </div>



        
      <div class="bg-white pt-3 pb-3">
        <div class="container">
          <div class="row">
            <div class="col-6">
              <!-- <a class="btn btn-primary fhbdark rounded-1 roundedmore mb-2 ms-3 ps-4 pe-4 fixwbtn"  href="/vendor/rfq/{{rfqId}}/{{quotationId}}"><i class="bi bi-pencil-square"></i> Edit</a> -->
              <a class="btn btn-link rounded-1 roundedmore mb-2 ms-3 ps-4 pe-4 c1"   href="/procurement/rfq/proforma-po/{{rfqId}}"><strong>Back</strong></a>
            </div>
            <div class="col-6 text-end">

            
              <button type="button"
                class="btn btn-primary fhbcyan rounded-1 roundedmore mb-2 ms-3 ps-4 pe-4 ">Download PDF</button>
              <!-- <a class="btn btn-primary fhbgred rounded-1 roundedmore fixwbtn mb-2 ms-3 ps-4 pe-4 {{(CheckIsVoid)?'disabled':''}}"  data-bs-toggle="modal" data-bs-target="#voidModal" >Void PO</a>
              <button type="button"
                class="btn btn-primary fhbcyan rounded-1 roundedmore mb-2 ms-3 ps-4 pe-4 fixwbtn {{(CheckIsSent)?'disabled':''}}" [ngClass]="{'disabled': CheckIsSent}" data-bs-toggle="modal"  data-bs-target="#publishModal">Send PO</button> -->

            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Confirm Modal -->
    <div class="modal fade" id="confirmModal" tabindex="-1">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content rounded-0 border-0">
          <div class="modal-header bg1 rounded-0 text-center">
            <h5 class="text-white f1 mb-0"><strong>Participate Confirmation</strong></h5>
          </div>
          <div class="modal-body">
            <h6 class="text-center mt-4 mb-4">
              Are you sure want to participate?
            </h6>
            <div class="d-grid gap-2 d-md-flex justify-content-md-center mb-3">
              <button type="button" class="btn c1 f1 pe-5 ps-5 cancelbtn text-uppercase fsmall"
                data-bs-dismiss="modal">Cancel</button>
              <button type="button" class="btn bg1 f1 text-white pe-5 ps-5 text-uppercase fsmall"
                data-bs-dismiss="modal">Yes</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Success Modal -->
    <div class="modal" id="successModal" tabindex="-1" role="dialog" [ngStyle]="{'display':displaydone}">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content rounded-0">
          <div class="modal-body pt-4 pb-4 ps-4 pe-4">
            <div class="text-center">
              <img class="saveimgicon" src="/assets/images/icons/done-save.png">
            </div>
            <h3 class="text-center mt-3 mb-2 f1">Success!</h3>
            <p class="text-center mt-0 mb-4 fw-bold">You has been successfully participated!</p>
            <div class="d-grid gap-2 d-md-flex justify-content-md-center mb-3 ">
              <a class="btn btn-secondary f1 bg1 fw-bold pt-2 pb-2 pe-5 ps-5 pointer" href="/vendor/rfq-board"
                data-bs-dismiss="modal">DONE</a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Error Modal -->
    <div class="modal" id="errorModal" tabindex="-1" role="dialog" [ngStyle]="{'display':displayerror}">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content rounded-0">
          <div class="modal-body pt-4 pb-4 ps-4 pe-4">
            <div class="text-center">
              <img class="saveimgicon" src="/assets/images/error.png">
            </div>
            <h3 class="text-center mt-3 mb-2 f1">Error!</h3>
            <p class="text-center mt-0 mb-4 fw-bold">{{errortext}}</p>
            <div class="d-grid gap-2 d-md-flex justify-content-md-center mb-3 ">
              <a class="btn btn-secondary f1 bg1 fw-bold pt-2 pb-2 pe-5 ps-5 pointer" (click)="closeError()">CLOSE</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<!-- Modal -->
<div class="modal" id="approveRejectModal" tabindex="-1"  [ngStyle]="{'display':displayApproveReject}">
  <div class="modal-dialog  modal-dialog-centered">
    <div class="modal-content  rounded-0 border-0">
      <div class="modal-header bg1 rounded-0  text-center">
        <h5 class="text-white f1 mb-0"><strong>Confirm</strong></h5>
        <button type="button" class="btn text-white" data-bs-dismiss="modal" (click)="openModalApproveReject()"><i class="bi bi-x-lg"></i></button>
      </div>
      <div class="modal-body">
        <h6 class="text-center mt-4 mb-4">
          Confirm PO? 
        </h6>


        
        <div class="d-grid gap-2 d-md-flex justify-content-md-center mb-3 ">
          
          <button type="button" class="btn pe-5 ps-5 cancelbtn text-uppercase fsmall text-white btn-danger" data-bs-dismiss="modal" (click)="reqeustApproval(quotationId,'REJECT')">Reject</button>
          <button type="button" class="btn  text-white pe-5 ps-5 text-uppercase fsmall btn-success"  data-bs-dismiss="modal" (click)="reqeustApproval(quotationId,'APPROVE')">Approve</button>
        </div>

      </div>

    </div>
  </div>
</div>



  <!-- Modal -->
  <div class="modal" tabindex="-1" role="dialog"  [ngStyle]="{'display':successpublish}">    
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content rounded-0">
  
        <div class="modal-body pt-4 pb-4 ps-4 pe-4">
          <div class="text-center">
            <img class="saveimgicon" src="/assets/images/icons/done-save.png">
          </div>  
          <h3 class="text-center mt-3 mb-2 f1">Success!</h3>
          <p class="text-center mt-0 mb-4 fw-bold">Your Quotation has been successfully PUBLISHED!</p>
          
          
          
          <div class="d-grid gap-2 d-md-flex justify-content-md-center mb-3 ">
            <!-- <a class="btn btn-secondary f1 bg1 fw-bold pt-2 pb-2 pe-5 ps-5 pointer" href="/procurement/rfq-list" data-bs-dismiss="modal">DONE</a> -->
            <a class="btn btn-secondary f1 bg1 fw-bold pt-2 pb-2 pe-5 ps-5 pointer" (click)="closeModal()" data-bs-dismiss="modal">DONE</a>
            
          </div>
  
        </div>
  
      </div>
    </div>
  </div>  
  
  
  <!-- Modal -->
  <div class="modal" tabindex="-1" role="dialog"  [ngStyle]="{'display':successvoid}">    
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content rounded-0">
  
        <div class="modal-body pt-4 pb-4 ps-4 pe-4">
          <div class="text-center">
            <img class="draftimgicon" src="/assets/images/icons/draft-save.png">
          </div>  
          <h3 class="text-center mt-3 mb-2 f1">Success!</h3>
          <p class="text-center mt-0 mb-4 fw-bold">Your Quotation has been successfully VOID!</p>
          
          <div class="d-grid gap-2 d-md-flex justify-content-md-center mb-3 ">
            <!-- <button type="button w-100" class="btn btn-secondary f1 bg1 fw-bold pt-2 pb-2 pe-5 ps-5" data-bs-dismiss="modal" (click)="openmodaldraft()">DONE</button> -->
            <!-- <a href="/procurement/rfq/detail/{{ rfqId }}" class="btn btn-secondary f1 bg1 fw-bold pt-2 pb-2 pe-5 ps-5">PREVIEW</a> -->
            <a (click)="closeModal()"  class="btn btn-secondary f1 bg1 fw-bold pt-2 pb-2 pe-5 ps-5">Close</a>
  
            
          </div>
  
        </div>
  
      </div>
    </div>
  </div>
  

    
  <!-- Modal -->
  <div class="modal fade" id="publishModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog  modal-dialog-centered">
      <div class="modal-content  rounded-0 border-0">
        <div class="modal-header bg1 rounded-0  text-center">
          <h5 class="text-white f1 mb-0"><strong>Publish Quotation</strong></h5>
        </div>
        <div class="modal-body">
          <h6 class="text-center mt-4 mb-4">
            Are you sure want to <b>PUBLISH</b> this Quotation ?
          </h6>
  
  
          
          <div class="d-grid gap-2 d-md-flex justify-content-md-center mb-3 ">
            <button type="button" class="btn c1 f1 pe-5 ps-5 cancelbtn text-uppercase fsmall" data-bs-dismiss="modal">Cancel</button>
            <button type="button" class="btn bg1 f1 text-white pe-5 ps-5 text-uppercase fsmall" data-bs-dismiss="modal" (click)="changeStateQuotation('PUBLISH')">Publish</button>
          </div>
  
        </div>
  
      </div>
    </div>
  </div>
  
  <!-- Modal -->
  <div class="modal fade" id="voidModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog  modal-dialog-centered">
      <div class="modal-content  rounded-0 border-0">
        <div class="modal-header bg1 rounded-0  text-center">
          <h5 class="text-white f1 mb-0"><strong>Void Product</strong></h5>
        </div>
        <div class="modal-body">
          <h6 class="text-center mt-4 mb-4">
            Are you sure want to <b>VOID</b> this Quotation ?
          </h6>
  
  
          
          <div class="d-grid gap-2 d-md-flex justify-content-md-center mb-3 ">
            <button type="button" class="btn c1 f1 pe-5 ps-5 cancelbtn text-uppercase fsmall" data-bs-dismiss="modal">Cancel</button>
            <button type="button" class="btn bg1 f1 text-white pe-5 ps-5 text-uppercase fsmall" data-bs-dismiss="modal" (click)="changeStateQuotation('VOID')">Void</button>
          </div>
  
        </div>
  
      </div>
    </div>
  </div>

    <!-- Modal -->
    <div class="modal fade" id="closeModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog  modal-dialog-centered">
        <div class="modal-content  rounded-0 border-0">
          <div class="modal-header bg1 rounded-0  text-center">
            <h5 class="text-white f1 mb-0"><strong>Close Product</strong></h5>
          </div>
          <div class="modal-body">
            <h6 class="text-center mt-4 mb-4">
              Are you sure want to <b>CLOSE</b> this Quotation ?
            </h6>
    
    
            
            <div class="d-grid gap-2 d-md-flex justify-content-md-center mb-3 ">
              <button type="button" class="btn c1 f1 pe-5 ps-5 cancelbtn text-uppercase fsmall" data-bs-dismiss="modal">Cancel</button>
              <button type="button" class="btn bg1 f1 text-white pe-5 ps-5 text-uppercase fsmall" data-bs-dismiss="modal" (click)="changeStateQuotation('CLOSE')">Void</button>
            </div>
    
          </div>
    
        </div>
      </div>
    </div>